import { formatHtml } from "@trumpf/ux.common-storybook";
import { Template } from "../../../components/data-table/data-table.template";

export default {
    title: "Website/Partial Templates/Technical Data Table",
    render: Template.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const Default = {};
